export default __webpack_public_path__ + "static/media/ic_clock_black.83bdc704.svg";